import React, { useEffect } from "react";

const FormModal = ({
  id,
  title,
  onSubmit,
  loading = false,
  setLoading,
  isEdited = true,
  btnText = "Submit",
  processingText = "Processing",
  children,
  closeBtnRef
}) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit?.();
  };

  useEffect(() => {
    const modalEl = document.getElementById(id);
    if (!modalEl) return;

    const handleHide = () => {
      // Fade out backdrop in sync with modal
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.classList.remove("show"));
    };

    const handleHidden = () => {
      // Only clean up after Bootstrap has completely finished its hide animation
      if (!document.querySelector(".modal.show")) {
        document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };

    modalEl.addEventListener("hide.bs.modal", handleHide);
    modalEl.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalEl.removeEventListener("hide.bs.modal", handleHide);
      modalEl.removeEventListener("hidden.bs.modal", handleHidden);
      if (!document.querySelector(".modal.show")) {
        document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };
  }, [id]);

  const handleBackdropClick = (e) => {
    // If user clicked directly on the modal outer area (outside modal-dialog)
    if (e.target === e.currentTarget) {
      if (closeBtnRef?.current) {
        closeBtnRef.current.click();
      }
    }
  };

  return (
    <div 
      className="modal fade" 
      id={id} 
      tabIndex="-1" 
      aria-hidden="true"
      onClick={handleBackdropClick}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content position-relative">

          {/* Close button */}
          <div className="d-flex justify-content-end pe-3 pt-3" style={{
              position: "absolute",
              top: "10px",
              right: "3px",
              zIndex: 1,
            }}>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}/>
          </div>

          <div className="modal-body px-5 mt-3">
            {title && (
              <h4 className="mb-5 text-center text-capitalize">
                {title}
              </h4>
            )}

            <form onSubmit={handleSubmit}>
              {children}

              <button type="submit" className="primary__btn confirm-walletBtn my-5 w-100" disabled={loading || !isEdited}>
                {loading ? (
                  <div className="spinner-border spinner-border-sm text-light" role="status">
                    <span className="visually-hidden">
                      {processingText}...
                    </span>
                  </div>
                ) : btnText}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormModal;

